export default "__VITE_ASSET__4ec495eb__"